import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { ICoverageApiDependencySegment } from '@cbridge-packages/api-coverage';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { CoverageServerAction } from '../coverageServer.action';
import { CoverageServerTranslator } from '../coverageServer.translator';

type IDependencies = ICoverageApiDependencySegment;

export const loadCoverageServerListEpic: IEpic<{}, IDependencies> = (action$, _, { coverageApi }) => action$.pipe(
  isTypeOfAndGetPayload(CoverageServerAction.loadList.started),
  mergeMap(() => coverageApi.getCoverageServers().pipe(
    mergeMap((response) => {
      const result = (response.servers ?? []).map(CoverageServerTranslator.fromApi);
      return [CoverageServerAction.loadList.done({ result })];
    }),
    catchApiError((error) => [
      CoverageServerAction.loadList.failed({ error }),
      createApiErrorNotification(error),
    ]),
  )),
);
